import { cva } from '@/styled-system/css';

export const propertyCardBadgeRecipe = cva({
  base: {
    borderRadius: 'shape.capsule',
    padding: '{spacing.micro.default} {spacing.tighter}',
    textStyle: 'body-xs-bold',
  },
  variants: {
    tone: {
      buyAbility: {
        backgroundColor: 'PropertyCard.Badge.buyAbility.bg',
        color: 'PropertyCard.Badge.buyAbility.label',
      },
      default: {
        backgroundColor: 'bg.transparent.impact-fixed',
        color: 'text.onImpact.neutral-fixed',
      },
      neutral: {
        backgroundColor: 'bg.neutral',
        color: 'text.neutral',
      },
      notify: {
        backgroundColor: 'bg.feedback.notify.hero-fixed',
        color: 'text.onHero.neutral-fixed',
      },
      zillow: {
        backgroundColor: 'bg.accent.brand.hero-fixed',
        color: 'text.onHero.neutral-fixed',
      },
    },
  },
});
